import React from 'react';
import { Check } from 'lucide-react';
import '../../App.css';

const ProgressBar = ({ currentStep, totalSteps }) => {
  const progress = (currentStep / totalSteps) * 100;
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <div className="onboarding-progress">
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <div className="step-circles">
        {steps.map((step) => {
          let circleClass = 'step-circle';
          if (step < currentStep) {
            circleClass += ' completed';
          } else if (step === currentStep) {
            circleClass += ' current';
          }

          return (
            <div key={step} className={circleClass}>
              {step < currentStep ? <Check size={14} /> : step}
            </div>
          );
        })}
      </div>
      <p className="step-indicator">
        Step {currentStep} of {totalSteps}
      </p>
    </div>
  );
};

export default ProgressBar;


